import { useState } from 'react';

const customStyles = {
  tape: {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    backdropFilter: 'blur(2px)',
    border: '1px solid rgba(255,255,255,0.2)',
    transform: 'rotate(-2deg)',
  },
  handDrawnBorder: {
    borderRadius: '255px 15px 225px 15px / 15px 225px 15px 255px',
    border: '2px solid #1F1F1F',
  },
  gridBg: {
    backgroundImage: 'linear-gradient(#1F1F1F 1px, transparent 1px), linear-gradient(90deg, #1F1F1F 1px, transparent 1px)',
    backgroundSize: '20px 20px',
  },
};

const Badge = ({ children }) => (
  <div className="px-4 py-2 border border-[#1F1F1F]/10 rounded-full font-typewriter text-xs uppercase tracking-widest bg-white/50 backdrop-blur-sm shadow-sm hover:scale-105 transition-transform cursor-default">
    {children}
  </div>
);

const MarketingCard = () => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className="relative w-full max-w-xs bg-white p-6 shadow-xl transition-transform duration-300 z-10 border border-[#D1D1C9] mb-8 lg:mb-0 group lg:absolute lg:top-0 lg:left-[5%]"
      style={{ transform: hovered ? 'rotate(0deg)' : 'rotate(-2deg)', position: 'relative' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-24 h-6 z-20" style={customStyles.tape}></div>

      <div className="flex items-start justify-between mb-4 border-b border-[#1F1F1F]/10 pb-4">
        <div className="flex flex-col">
          <span className="text-[10px] uppercase tracking-widest text-[#C65D3B] font-typewriter">Agent 01</span>
          <h3 className="text-2xl font-bold font-serif-display">Маркетолог</h3>
        </div>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center text-[#1F1F1F] border border-[#1F1F1F]/10 transition-colors ${hovered ? 'bg-[#b7eb6f]' : 'bg-[#F4F1EA]'}`}>
          <i className="ph ph-target text-xl"></i>
        </div>
      </div>

      <p className="text-xs text-[#1F1F1F]/70 leading-relaxed mb-4 font-typewriter">
        Анализ воронки, уникального торгового предложения (УТП) и болей клиента.
      </p>

      <div className="flex flex-wrap gap-2">
        <span className="px-2 py-1 border border-[#1F1F1F] rounded text-[9px] uppercase tracking-wider font-sans">Структура</span>
        <span className="px-2 py-1 border border-[#1F1F1F] rounded text-[9px] uppercase tracking-wider font-sans">Смыслы</span>
      </div>

      <div className="absolute -right-4 top-12 transform rotate-12 opacity-80">
        <div className="w-16 h-16 border-2 border-[#C65D3B] rounded-full flex items-center justify-center p-1">
          <span className="text-[8px] font-bold text-[#C65D3B] uppercase text-center leading-tight -rotate-12 font-typewriter">Check<br />Market<br />Fit</span>
        </div>
      </div>
    </div>
  );
};

const AnalystCard = () => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className="relative w-full max-w-xs bg-[#F9F7F2] p-6 shadow-xl transition-transform duration-300 z-10 border border-[#D1D1C9] mb-8 lg:mb-0 group lg:absolute lg:top-4 lg:right-[5%]"
      style={{ transform: hovered ? 'rotate(0deg)' : 'rotate(1deg)' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="absolute -top-3 right-8 w-16 h-6 z-20" style={customStyles.tape}></div>
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={customStyles.gridBg}></div>

      <div className="flex items-start justify-between mb-4 relative z-10">
        <div className="flex flex-col">
          <span className="text-[10px] uppercase tracking-widest text-[#1F1F1F]/50 font-typewriter">Agent 02</span>
          <h3 className="text-2xl font-bold font-serif-display">Аналитик</h3>
        </div>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center border border-[#1F1F1F]/10 transition-colors ${hovered ? 'bg-[#C65D3B] text-white' : 'bg-white text-[#1F1F1F]'}`}>
          <i className="ph ph-chart-line-up text-xl"></i>
        </div>
      </div>

      <p className="text-xs text-[#1F1F1F]/70 leading-relaxed mb-4 relative z-10 font-typewriter">
        Оценка вероятности CTR и конверсии на основе исторических данных.
      </p>

      <div className="relative z-10 bg-[#1F1F1F] text-[#F4F1EA] p-3 rounded text-[10px] font-typewriter">
        &gt; Calculating...<br />
        &gt; Probability: <span className="text-[#b7eb6f]">High</span><br />
        &gt; Risk: Low
      </div>
    </div>
  );
};

const DesignerCard = () => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className="relative w-full max-w-xs bg-white p-6 shadow-xl transition-transform duration-300 z-10 border-l-4 border-l-[#b7eb6f] border-t border-r border-b border-t-[#D1D1C9] border-r-[#D1D1C9] border-b-[#D1D1C9] mb-8 lg:mb-0 group lg:absolute lg:bottom-4 lg:left-[10%]"
      style={{ transform: hovered ? 'rotate(0deg)' : 'rotate(3deg)' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex flex-col">
          <span className="text-[10px] uppercase tracking-widest text-[#b7eb6f] font-typewriter">Agent 03</span>
          <h3 className="text-2xl font-bold font-serif-display">Дизайнер</h3>
        </div>
        <div className={`w-10 h-10 rounded-full bg-[#F4F1EA] flex items-center justify-center text-[#1F1F1F] border border-[#1F1F1F]/10 transition-transform ${hovered ? 'scale-110' : ''}`}>
          <i className="ph ph-pen-nib text-xl"></i>
        </div>
      </div>

      <div className="space-y-3 mb-4">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full border border-[#1F1F1F] bg-[#C65D3B]"></div>
          <span className="text-[10px] uppercase font-typewriter">Контраст</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full border border-[#1F1F1F] bg-[#b7eb6f]"></div>
          <span className="text-[10px] uppercase font-typewriter">Шум</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full border border-[#1F1F1F] bg-[#F4F1EA]"></div>
          <span className="text-[10px] uppercase font-typewriter">Читаемость</span>
        </div>
      </div>

      <p className="text-xs text-[#1F1F1F]/70 leading-relaxed border-t border-dashed border-[#1F1F1F]/20 pt-3 font-typewriter">
        Проверка визуального шума и акцентов.
      </p>
    </div>
  );
};

const BuyerCard = () => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className="relative w-full max-w-xs bg-[#b7eb6f] text-[#1F1F1F] p-6 shadow-xl transition-transform duration-300 z-10 mb-8 lg:mb-0 group lg:absolute lg:bottom-0 lg:right-[10%]"
      style={{ ...customStyles.handDrawnBorder, transform: hovered ? 'rotate(0deg)' : 'rotate(-1deg)' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="absolute -top-4 left-1/2 w-4 h-4 rounded-full bg-[#C65D3B] shadow-md z-20 border border-white/20"></div>

      <div className="flex items-start justify-between mb-4">
        <div className="flex flex-col">
          <span className="text-[10px] uppercase tracking-widest opacity-60 font-typewriter">Agent 04</span>
          <h3 className="text-2xl font-bold italic font-serif-display">Покупатель</h3>
        </div>
        <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-[#1F1F1F] border border-[#1F1F1F]/10">
          <i className="ph ph-shopping-bag text-xl"></i>
        </div>
      </div>

      <div className="bg-white/90 p-3 transform rotate-1 shadow-sm mb-3">
        <p className="text-lg italic leading-tight font-serif-display">
          "Кликну ли я?<br />Доверяю ли я?"
        </p>
      </div>

      <p className="text-xs opacity-80 leading-relaxed font-typewriter">
        Реагирует как реальный клиент, оценивая эмоции и доверие.
      </p>
    </div>
  );
};

const AICenter = () => (
  <div className="lg:absolute lg:top-1/2 lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:-translate-y-1/2 z-20 mb-12 lg:mb-0">
    <div className="relative w-48 h-48 bg-[#1F1F1F] text-[#F4F1EA] rounded-full flex flex-col items-center justify-center text-center p-6 shadow-2xl ring-8 ring-[#F4F1EA] ring-opacity-50">
      <i className="ph ph-brain text-4xl mb-2 text-[#b7eb6f]"></i>
      <span className="text-2xl italic leading-none block font-serif-display">AI</span>
      <span className="text-xs uppercase tracking-[0.2em] opacity-80 mt-1 block font-typewriter">Brainstorm</span>
      <div className="absolute -bottom-4 bg-[#b7eb6f] text-[#1F1F1F] px-4 py-1 text-[10px] uppercase font-bold tracking-widest shadow-md transform rotate-2 font-typewriter">
        Processing
      </div>
    </div>
  </div>
);

const TestingSection = () => {
  const [btnHovered, setBtnHovered] = useState(false);

  return (
    <section className="py-24 relative overflow-hidden" style={{ backgroundColor: '#F4F1EA' }}>
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        
        {/* Header */}
        <header className="mb-20 text-center relative">
          <div className="inline-block relative">
            <h1 className="text-5xl lg:text-7xl font-light italic text-[#1F1F1F] leading-[0.9] mb-6 relative z-10 font-serif-display">
              Проверьте карточку<br />
              <span className="ml-12 not-italic font-normal text-[#C65D3B]">до того, как</span><br />
              потратите деньги.
            </h1>

            <div className="absolute -top-10 -right-10 w-32 h-32 border border-[#b7eb6f] rounded-full opacity-50 -z-10"></div>
            <div className="absolute top-10 -left-16 w-24 h-24 border border-dashed border-[#1F1F1F]/20 rounded-full -z-10"></div>
          </div>

          <p className="text-sm lg:text-base max-w-2xl mx-auto text-[#1F1F1F]/80 leading-relaxed mt-4 font-typewriter">
            Маркетолог, аналитик, дизайнер и покупатель устроят{' '}
            <span className="bg-[#b7eb6f]/30 px-1">мозговой штурм</span> вашей карточки и дадут:
          </p>

          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <Badge>● прогноз конверсии</Badge>
            <Badge>● анализ слабых мест</Badge>
            <Badge>● оценка CTR</Badge>
            <Badge>● предложения</Badge>
          </div>
        </header>

        {/* Cards Section */}
        <div className="relative w-full h-auto min-h-[600px] flex flex-col items-center justify-center lg:block">

          {/* SVG connections */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none hidden lg:block z-0" viewBox="0 0 1200 600">
            <path d="M250,150 Q400,200 550,280" fill="none" stroke="#D1D1C9" strokeWidth="2" strokeDasharray="8 8"></path>
            <path d="M950,150 Q800,200 650,280" fill="none" stroke="#D1D1C9" strokeWidth="2" strokeDasharray="8 8"></path>
            <path d="M250,450 Q400,400 550,320" fill="none" stroke="#D1D1C9" strokeWidth="2" strokeDasharray="8 8"></path>
            <path d="M950,450 Q800,400 650,320" fill="none" stroke="#D1D1C9" strokeWidth="2" strokeDasharray="8 8"></path>
            <circle cx="600" cy="300" r="80" fill="none" stroke="#b7eb6f" strokeWidth="1"></circle>
            <circle cx="600" cy="300" r="75" fill="none" stroke="#b7eb6f" strokeWidth="4" strokeOpacity="0.2"></circle>
          </svg>

          {/* AI Center */}
          <AICenter />

          {/* Agent Cards */}
          <MarketingCard />
          <AnalystCard />
          <DesignerCard />
          <BuyerCard />
        </div>

        {/* CTA Section */}
        <div className="mt-20 lg:mt-32 text-center border-t border-[#1F1F1F]/10 pt-12 relative">
          <div className="absolute left-1/2 -translate-x-1/2 -top-3 px-4 bg-[#F4F1EA] text-[#1F1F1F]/30 text-xs font-typewriter">
            EST. 2024
          </div>

          <h2 className="text-3xl lg:text-4xl text-[#1F1F1F] mb-4 font-serif-display">
            Вы тестируете не деньгами.<br />
            <span className="italic text-[#C65D3B]">Вы тестируете интеллектом.</span>
          </h2>

          <a
            href="https://trippika.ru/seller-login"
            className="mt-8 px-8 py-3 text-[#F4F1EA] text-xs uppercase tracking-widest transition-colors duration-300 shadow-lg inline-flex items-center gap-2 font-typewriter"
            style={{
              backgroundColor: btnHovered ? '#C65D3B' : '#1F1F1F',
            }}
            onMouseEnter={() => setBtnHovered(true)}
            onMouseLeave={() => setBtnHovered(false)}
          >
            <span>Запустить анализ</span>
            <i className={`ph ph-arrow-right transition-transform ${btnHovered ? 'translate-x-1' : ''}`}></i>
          </a>
        </div>

      </div>
    </section>
  );
};

export default TestingSection;
